module.exports = __webpack_public_path__ + "static/media/ge.e6e6de60.svg";